import React from 'react'

import { useNavigate } from 'react-router-dom';
import { useCompleteSignIn, useUpdateAccountDetails } from "../../hooks/authhooks";

// import { ResourceCardProps } from "../../data/types";
import StarRating from './StarRating';

import { ReactComponent as HeartIcon } from "../../icons/HeartIcon.svg";
import { ReactComponent as HeartOutlineIcon } from "../../icons/HeartOutlineIcon.svg";
import { ReactComponent as LocationIcon } from "../../icons/locationIcon.svg";

import { capitalizeString, getEmailFromAccessToken, getDirectLinkFromGoogleDriveSharedLink, getActionButtonLabel, getUIDFromAccessToken } from '../../utils/helpers';
import { ResourceSchema, ResourceType, SearchFilterOptionType } from '../../data/types';
import { useLoadCurrentResource } from '../../hooks/apphooks';


type ResourceCardProps = {
  resource: ResourceSchema;
  resourceIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  resourceType: ResourceType
  searchFilterOptions?: SearchFilterOptionType
  isMobile?: boolean
  isModal?: boolean
  toggleApplyModal: React.Dispatch<React.SetStateAction<ResourceType | undefined>>
  setApplyResource: React.Dispatch<React.SetStateAction<ResourceSchema>>
  // allMemberships: MembershipSchema[]
}

const ResourceCard: React.FC<ResourceCardProps> = ({isMobile, isModal, resourceType, resource, searchFilterOptions, resourceIcon: ResourceIcon, toggleApplyModal, setApplyResource}) => {
    // const [showLogo, updateShowLogo] = useState(true) 
    const navigate = useNavigate();

    const { getSavedResourceTruths } = useCompleteSignIn()
    const savedResources = getSavedResourceTruths()
    const setSignInModalIsOpen =  searchFilterOptions?.setSignInModalIsOpen
  
    // console.log("savedResources", savedResources)


    const getBgColor  = () => {
      // let memberStatus = findObjectByAttribute(memberships, "community_id", community?.id)?.status
      // return memberStatus ? getMembershipStatusColor(memberStatus).bgColor : "#bbb"
      return '#fff'
    }

    const getPrimaryTextColor  = () => {
      // let memberStatus = findObjectByAttribute(memberships, "community_id", community?.id)?.status
      // return memberStatus ? getMembershipStatusColor(memberStatus).primaryTextColor : "#202124"
      return '#202124'
    }

    const getSecondaryTextColor  = () => {
      // let memberStatus = findObjectByAttribute(memberships, "community_id", community?.id)?.status
      // return memberStatus ? getMembershipStatusColor(memberStatus).secondaryTextColor : "#696969"
      return '#696969'
    }

    const { currentResource } = useLoadCurrentResource(resource.id ? resource.id : "")
    resource = currentResource ? currentResource : resource

    const handleCardClick = async () => {
      if (resourceType && resource?.id){
        navigate(`/${resourceType}/${resource.id}`)
      }
    }

    const openInNewTab = (url: string) => {
      if (url){
        window.open(url, "_blank");
      }
    };

    const loggedinUsername = getEmailFromAccessToken(localStorage.getItem('accessToken'))
    const loggedinUid = getUIDFromAccessToken(localStorage.getItem('accessToken'))

    const { saveResource, removeResource } = useUpdateAccountDetails(loggedinUid)

    const handleSaveResource = () => {
      if (resource && resource.id){
        if (!loggedinUsername && setSignInModalIsOpen){
          setSignInModalIsOpen(true)
        } else if (loggedinUsername) {
          saveResource(resource.id)
        }
      }
    }
  
    const handleRemoveSavedResource = () => {
      if (resource && resource.id){
        removeResource(resource.id)
      }
    }

    var actionButtonLabel = getActionButtonLabel(resourceType)

    if (isMobile){
      return (
          <div  className={`flex flex-col min-h-[200px] object-cover rounded-xl border-[1px] border-[#E9E9E9] ${isModal ? 'w-full max-w-full' : 'w-[360px]'} mx-auto shadow-sm items-center text-start p-4 bg-gradient-to-a hover:bg-gradient-to-b from-[#f9f9f9] mt-5 overflow-hidden`} 
                style={{backgroundColor: getBgColor(), opacity: 0.9}} 
          >

            <div className='flex flex-row '>
              {
                resource.active && (<div className='flex my-2 w-[86px] rounded-2xl bg-[#E7F5EC]'>
                  <p className='m-auto text-[#0F973D] text-[14px] font-raleway font-normal'>Available</p>
                </div>)
              }
            </div>

              <div className='flex flex-col m-2 w-full'>
                <div className='flex flex-row'>
                  <div className='p-2 border-[#E9E9E9] w-16 border-[1px] rounded-md mr-auto my-2'>
                    {
                      getDirectLinkFromGoogleDriveSharedLink(resource?.logo) ? (
                        <img className=' h-10 aspect-auto object-contain' src={getDirectLinkFromGoogleDriveSharedLink(resource.logo)} alt={resource?.id} /> 
                        ) : (
                          <ResourceIcon className={'relative m-1 w-10 aspect-square p-1 text-[#5DB6CE]/60 '} />
                          )
                    }
                  </div>
                  <div className='flex border-[1px] border-[#E9E9E9] text-[14px] h-[44px] ml-auto rounded-xl text-primaryDark-0'>
                  {
                    (savedResources && resource && resource?.id && !savedResources[resource.id])? (
                      <div className='flex flex-row text-black px-3 cursor-pointer' onClick={handleSaveResource}>
                        <HeartOutlineIcon className='text-black w-[16px] h-[15px] my-auto' />
                        <p className='mx-2 my-auto'>Save</p>
                      </div>
                    ) : (
                      <div className='flex flex-row text-primaryDark-400 px-3 cursor-pointer' onClick={handleRemoveSavedResource}>
                        <HeartIcon className='text-primaryDark-400 w-[16px] h-[15px] my-auto' />
                        <p className='mx-2 my-auto'>Saved</p>
                      </div>
                    )
                  }
                  </div>
                </div>
                  <p 
                    className='font-raleway font-semibold px-2 text-[18px] my-1 text-primaryDark-0 break-words'
                  >
                    {resource.name}
                  </p>
                  <p className='px-2 font-raleway text-[14px] flex flex-row items-start pt-1 text-[#8A8A8A] mb-4 break-words'>
                    <LocationIcon className="mr-1 mt-[1px] w-[16px] h-[16px] text-gray flex-shrink-0" />
                    <span className="break-words overflow-wrap-anywhere">
                      {resource && resource.address ? `${resource.address}, `: ``} 
                      {resource && resource.city ? `${resource.city}, `: ``} 
                      {resource && resource.state ? `${resource.state} `: ``}  
                      {resource && resource.zipcode ? `${resource.zipcode} `: ``}  
        
                      {
                        (resource && 
                          !(resource.address && resource.city && resource.state && resource.zipcode)
                        ) ? `Nationwide`: ``
                      }
                    </span>
                  </p>
              </div>
           
              <button 
                onClick={() => openInNewTab(resource?.website ? resource.website : '')}
                className={`text-primaryDark-0 bg-white text-[14px] h-[51px] rounded-lg font-semibold border-[1px] border-[#E9E9E9] w-full mb-3 'h-auto'}`}
              >
                Visit Website
              </button>

              <button onClick={handleCardClick} className={`text-white bg-primaryDark-0 text-[14px] h-[51px] rounded-lg font-semibold border-0 w-full mb-3 ${(resource?.name && resource.name?.length <= 35) ? 'h-[51px]': 'h-auto'}`}>
                View {capitalizeString(resource.name ? resource.name : resourceType)}
              </button>
              {
                  (resource && resource.active && actionButtonLabel) ? (
                    <button 
                      onClick={()=> {
                        if (!loggedinUsername && setSignInModalIsOpen !== undefined){
                            setSignInModalIsOpen(true)
                        } else {
                          toggleApplyModal(resourceType)
                          setApplyResource(resource)
                        }
                        

                      }} 
                      className={`text-white rounded-md bg-primaryDark-300 text-[14px] h-[51px] font-bold border-0 w-full mb-3}`}>
                        {actionButtonLabel}
                    </button>
                  ) : (
                    <></>
                  )
                }
          </div>
          )
    } else {
      // Modal version - more compact design
      if (isModal) {
        return (
          <div className={`flex flex-col w-full max-w-full rounded-lg border border-[#E9E9E9] bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden`}>
            {/* Top section with status badge */}
            <div className='flex flex-row items-start justify-between p-3 sm:p-4 pb-2 min-w-0 overflow-hidden'>
              <div className="flex flex-row items-center gap-2 sm:gap-3 flex-1 min-w-0 overflow-hidden">
                {/* Logo */}
                <div className='flex-shrink-0 p-1.5 sm:p-2 border border-[#E9E9E9] w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#FAFAFA] flex items-center justify-center'>
                  {
                    getDirectLinkFromGoogleDriveSharedLink(resource?.logo) ? (
                      <img className='h-7 w-7 sm:h-8 sm:w-8 aspect-auto object-contain' src={getDirectLinkFromGoogleDriveSharedLink(resource.logo)} alt={resource?.id} /> 
                    ) : (
                      <ResourceIcon className={'w-7 h-7 sm:w-8 sm:h-8 text-[#5DB6CE]/60'} />
                    )
                  }
                </div>
                
                {/* Name and Rating */}
                <div className='flex flex-col flex-1 min-w-0 overflow-hidden'>
                  <div className="flex flex-row items-center gap-1.5 sm:gap-2 mb-1 min-w-0">
                    <h3 className='font-raleway font-semibold text-[15px] sm:text-[17px] text-primaryDark-0 truncate flex-1 min-w-0'>
                      {resource.name}
                    </h3>
                    {resource.active && (
                      <div className='flex-shrink-0 px-1.5 sm:px-2 py-0.5 rounded-full bg-[#E7F5EC]'>
                        <p className='text-[10px] sm:text-[11px] font-raleway text-[#0F973D] font-medium whitespace-nowrap'>Available</p>
                      </div>
                    )}
                  </div>
                  {resource?.rating && (
                    <div className='flex flex-row items-center'>
                      <StarRating review_rating={resource.rating} />
                    </div>
                  )}
                </div>
              </div>
              
              {/* Save button */}
              <div className="flex-shrink-0 ml-1.5 sm:ml-2">
                {
                  (savedResources && resource && resource?.id && !savedResources[resource.id]) ? (
                    <button 
                      onClick={handleSaveResource}
                      className='flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-lg border border-[#E9E9E9] hover:bg-gray-50 transition-colors text-[#013847]'
                      aria-label="Save resource"
                    >
                      <HeartOutlineIcon className='w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0' style={{ display: 'block' }} />
                    </button>
                  ) : (
                    <button 
                      onClick={handleRemoveSavedResource}
                      className='flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-lg border border-[#E9E9E9] hover:bg-[#D4EDDA] transition-colors text-[#013847]'
                      aria-label="Remove saved resource"
                    >
                      <HeartIcon className='w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0' style={{ display: 'block' }} />
                    </button>
                  )
                }
              </div>
            </div>

            {/* Address */}
            <div className='px-3 sm:px-4 pb-3 min-w-0 overflow-hidden'>
              <p className='font-raleway text-[12px] sm:text-[14px] flex flex-row items-start text-[#8A8A8A] leading-relaxed min-w-0'>
                <LocationIcon className="mr-1.5 mt-0.5 w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#8A8A8A] flex-shrink-0" />
                <span className="flex-1 min-w-0 break-words overflow-wrap-anywhere">
                  {resource && resource.address ? `${resource.address}, `: ``} 
                  {resource && resource.city ? `${resource.city}, `: ``} 
                  {resource && resource.state ? `${resource.state} `: ``}  
                  {resource && resource.zipcode ? `${resource.zipcode} `: ``}  
                  {
                    (resource && 
                      !(resource.address && resource.city && resource.state && resource.zipcode)
                    ) ? `Nationwide`: ``
                  }
                </span>
              </p>
            </div>

            {/* Action buttons */}
            <div className='flex flex-row gap-2 px-3 sm:px-4 pb-3 sm:pb-4 min-w-0'>
              <button 
                onClick={handleCardClick} 
                className="flex-1 min-w-0 text-primaryDark-0 hover:bg-gray-50 font-raleway font-semibold text-[13px] sm:text-[14px] border border-[#E9E9E9] h-[42px] sm:h-[44px] rounded-lg transition-colors whitespace-nowrap"
              >
                View Details
              </button>
              {resource?.website && (
                <button 
                  onClick={() => openInNewTab(resource.website || '')}
                  className="flex-1 min-w-0 text-white bg-primaryDark-0 hover:bg-primaryDark-300 font-raleway font-semibold text-[13px] sm:text-[14px] border-0 h-[42px] sm:h-[44px] rounded-lg transition-colors whitespace-nowrap"
                >
                  Website
                </button>
              )}
            </div>
          </div>
        )
      }
      
      // Desktop version (non-modal)
      return (
        <div className={`flex flex-col ${resource.active ? 'h-[140px] ' : 'h-[120px] sm:h-[112px]'} ${isModal ? 'w-full' : 'w-[1152px]'} object-cover rounded-xl border-0 mx-auto my-auto shadow-sm  text-start p-4 bg-gradient-to-a hover:bg-gradient-to-b from-[#f9f9f9] mt-5`} 
            style={{backgroundColor: getBgColor(), opacity: 0.9}} 
        >
            <div className='flex flex-row '>
              {
                resource.active && (<div className='flex my-2 w-[86px] rounded-2xl bg-[#E7F5EC]'>
                  <p className='m-auto text-[#0F973D] text-[14px] font-raleway font-normal'>Available</p>
                </div>)
              }
            </div>

            <div className='flex flex-row '>
              <div className='p-2 border-[#E9E9E9] w-16 border-[1px] rounded-md my-auto'>
                {
                  getDirectLinkFromGoogleDriveSharedLink(resource?.logo) ? (
                    <img className=' h-10 aspect-auto object-contain' src={getDirectLinkFromGoogleDriveSharedLink(resource.logo)} alt={resource?.id} /> 
                    ) : (
                      <ResourceIcon className={'relative m-1 w-10 aspect-square p-1 text-[#5DB6CE]/60 '} />
                      )
                }
              </div>

              <div className='flex flex-col w-2/3 m-2'>
                  <span 
                    className='flex flex-row font-open-sans font-semibold px-2 text-sm sm:text-md'
                    style={{color: getPrimaryTextColor()}}
                  >
                    {resource.name}
                    {
                      resource?.rating ? (
                        <div className='flex flex-row flex-start mx-2 my-auto'>
                          <StarRating review_rating={resource.rating} />
                        </div>
                      ) : (<></>)
                    }
                  </span>
                  <p className='px-2 font-open-sans text-xs sm:text-sm flex flex-row pt-1' style={{color: getSecondaryTextColor(), opacity: 0.8}}>
                    <LocationIcon className="mr-1 mt-[1px] w-[16px] h-[16px] text-gray" />
                    {resource && resource.address ? `${resource.address}, `: ``} 
                    {resource && resource.city ? `${resource.city}, `: ``} 
                    {resource && resource.state ? `${resource.state} `: ``}  
                    {resource && resource.zipcode ? `${resource.zipcode} `: ``}  
                  {/* </p>

                  <p className='px-2 font-open-sans text-xs sm:text-sm' style={{color: getSecondaryTextColor(), opacity: 0.8}}> */}
                    {
                      (resource && 
                        !(resource.address && resource.city && resource.state && resource.zipcode)
                      ) ? `Nationwide`: ``
                    }
                  </p>

              </div>
              <div className="flex flex-row gap-2 ml-auto">
                {
                  (savedResources && resource && resource?.id && !savedResources[resource.id])? (
                    <div className='flex flex-row text-black px-3 cursor-pointer' onClick={handleSaveResource}>
                      <HeartOutlineIcon className='text-black w-[16px] h-[15px] my-auto' />
                      <p className='mx-2 my-auto'>Save</p>
                    </div>
                  ) : (
                    <div className='flex flex-row text-primaryDark-400 px-3 cursor-pointer' onClick={handleRemoveSavedResource}>
                      <HeartIcon className='text-primaryDark-400 w-[16px] h-[15px] my-auto' />
                      <p className='mx-2 my-auto'>Saved</p>
                    </div>
                  )
                }
                <button 
                  onClick={handleCardClick} 
                  className="text-primaryDark-0 hover:bg-gray-100 font-semibold border-[1px] border-[#E9E9E9] w-[146px] h-auto my-auto rounded-md"
                >
                  View {capitalizeString(resourceType)}
                </button>
               
                {
                  (resource && resource.active && actionButtonLabel && !isModal) ? (
                    <button 
                      onClick={()=> {
                        if (!loggedinUsername && setSignInModalIsOpen !== undefined){
                            setSignInModalIsOpen(true)
                        } else {
                          toggleApplyModal(resourceType)
                          setApplyResource(resource)
                        }
                      }} 
                      className="text-white rounded-md font-semibold bg-primaryDark-0 w-[146px] h-auto my-auto">
                        {actionButtonLabel}
                    </button>
                  ) : (
                    <></>
                  )
                }
              </div>
            </div>
        </div>
      )
    }



  }




export default ResourceCard
